import { runInInjectionContext, inject, Injector } from '@angular/core';
import { FilesService } from 'app/shared/files.service';
import { HttpUtils } from 'app/shared/http-utils';
import { NotificationService } from 'app/shared/notification.service';
import { TextService } from 'app/shared/text.service';
import { catchError, EMPTY } from 'rxjs';

export class FacetHooks {
  static uploadFile(
    injector: Injector,
    facetId: string,
    imageFile: File | string,
    fileApiUrl: string,
    uploadFileFromUrl?: boolean,
  ) {
    return runInInjectionContext(injector, () => {
      const filesService = inject(FilesService);
      const text = inject(TextService);
      const notification = inject(NotificationService);

      if (imageFile instanceof File) {
        return filesService.uploadFile(imageFile, `${fileApiUrl}/${facetId}`).pipe(
          catchError((err) => {
            notification.error(text.get('failed_upload_image'));
            throw err;
          }),
        );
      } else if (uploadFileFromUrl) {
        return filesService.uploadFileFromUrl(imageFile, `${fileApiUrl}/${facetId}`).pipe(
          catchError((err) => {
            notification.error(text.get('failed_upload_image'));
            throw err;
          }),
        );
      } else {
        return EMPTY;
      }
    });
  }

  static downloadFile(injector: Injector, facetId: string, fileApiUrl = HttpUtils.getApiUrl('/files/chapters')) {
    return runInInjectionContext(injector, () => {
      const filesService = inject(FilesService);

      return filesService.getFile(`${fileApiUrl}/${facetId}`);
    });
  }
}
